import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';

import { useFormCreateCategory } from '../../controllers/Category/CreateCategoryController';
import LoadingScreen from '../../components/LoadingScreen';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';

const CategoryForm: React.FC = () => {
	const { getCategoryFormController, handleCategoryFormController } = useFormCreateCategory();
	const history = useHistory();

	const [registerFinished, setRegisterFinished] = useState(false);

	useEffect(() => {
		if (getCategoryFormController.categoryResponse?.status === 200) {
			setRegisterFinished(true);
		}
		if (
			getCategoryFormController.categoryEditedResponse?.status === 200 &&
			!getCategoryFormController.categoryResponse
		) {
			setRegisterFinished(false);
		}
	}, [getCategoryFormController.categoryResponse, getCategoryFormController.categoryEditedResponse]);

	return (
		<div style={{ height: '100%' }} className='p-grid p-align-center p-justify-center'>
			<Toast ref={getCategoryFormController.toast} />
			{getCategoryFormController.loading ? <LoadingScreen color='#0388e5' /> : <></>}
			<div className='p-col-12 p-md-8'>
				<div className='card p-fluid'>
					<h5>Categoria</h5>
					<div className='p-field'>
						<label htmlFor='name'>Nome</label>
						<InputText
							id='name'
							type='text'
							maxLength={150}
							disabled={registerFinished}
							value={getCategoryFormController.formik.values.DESCRICAO}
							onChange={getCategoryFormController.formik.handleChange('DESCRICAO')}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getCategoryFormController.formik.touched.DESCRICAO &&
									getCategoryFormController.formik.errors.DESCRICAO,
								'popup-form-inactive': !(
									getCategoryFormController.formik.touched.DESCRICAO &&
									getCategoryFormController.formik.errors.DESCRICAO
								),
							})}>
							{getCategoryFormController.formik.errors.DESCRICAO}
						</div>
					</div>
					<div className='p-fluid p-grid p-justify-between'>
						{getCategoryFormController.categoryResponse?.status === 200 && !registerFinished ? (
							<div className='p-col-12 p-md-4'>
								<Button
									type='button'
									label='Salvar Alterações'
									onClick={() => {
										getCategoryFormController.formik.handleSubmit();
									}}
								/>
							</div>
						) : getCategoryFormController.categoryResponse?.status === 200 && registerFinished ? (
							<div className='p-col-12 p-md-6 p-fluid p-grid'>
								<div className='p-col-12 p-md-5'>
									<Button
										type='button'
										label='Editar'
										onClick={() => {
											setRegisterFinished(false);
										}}
									/>
								</div>
								<div className='p-col-12 p-md-5'>
									<Button
										icon='pi pi-plus'
										type='button'
										className='p-button-success'
										label='Cadastrar novo'
										onClick={() => {
											getCategoryFormController.formik.resetForm();
											setRegisterFinished(false);
											handleCategoryFormController.setCategoryResponse(null);
										}}
									/>
								</div>
							</div>
						) : (
							<div className='p-col-12 p-md-4'>
								<Button
									type='button'
									label='Cadastrar'
									onClick={() => getCategoryFormController.formik.handleSubmit()}
								/>
							</div>
						)}

						<div className='p-col-12 p-md-4'>
							<Button
								type='button'
								className='p-button-secondary'
								label='Voltar para listagem'
								onClick={() => history.goBack()}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CategoryForm;
